import React from 'react'
import classnames from 'classnames'
import Link from 'redux-first-router-link'
import IconAnswered from 'react-icons/lib/md/check'
import IconComment from 'react-icons/lib/md/chat'
import IconCurrent from 'react-icons/lib/md/keyboard-arrow-right'
import { connect } from 'react-redux'
import Tooltip from './Tooltip.js'
import {
  getQuestionsById,
  getCurrentQuestionId,
  getAnswersByQuestionId,
  getCommentsByQuestionId,
} from '../selectors.js'
import './QuestionNavLink.css'

const QuestionNavLink = ({
  question,
  number,
  isCurrentQuestion,
  answer,
  comment,
}) => {
  const { body } = question

  const linkClasses = classnames({
    QuestionNavLink: true,
    noselect: true,
    isCurrentQuestion,
    isAnswered: !!answer,
  })

  const Number = isCurrentQuestion ? <IconCurrent /> : number

  const action = {
    type: 'currentQuestionId/set',
    payload: { questionId: question.id },
  }

  const CheckIcon = comment ? (
    <Tooltip title={comment}>
      <IconComment />
    </Tooltip>
  ) : (
    answer && <IconAnswered />
  )

  return (
    <div className={linkClasses}>
      <div className="number">{Number}</div>
      <Link to={action} className="body">
        {body}
      </Link>
      <div className="answer">
        {CheckIcon} {answer && answer.value}
      </div>
    </div>
  )
}

const mapStateToProps = (state, { id }) => ({
  question: getQuestionsById(state)[id],
  isCurrentQuestion: id === getCurrentQuestionId(state),
  answer: getAnswersByQuestionId(state)[id],
  comment: getCommentsByQuestionId(state)[id],
})

export default connect(mapStateToProps)(QuestionNavLink)



// WEBPACK FOOTER //
// ./src/components/QuestionNavLink.js